import css from "./Loader.module.css";

const Loader = () => {
  return <div className={css.loader}>Loading...</div>;
};

export default Loader;

